document.addEventListener('DOMContentLoaded', function () {
    const cartDrawer = document.getElementById('cart-drawer');
    let targetTime = sessionStorage.getItem('cartTimerTarget');
    let timerExpired = sessionStorage.getItem('cartTimerExpired');
    const defaultCountdownHTML = `
      <span class="timer-text">We can only reserve your product for</span>
      <span class="countdown-minutes">20</span><span class="letter">m</span>
      <span class="countdown-seconds">00</span><span class="letter">s</span>
    `;
  
    function observeCountdownElement(el) {
      if (el._observerAttached) return;
      const observer = new MutationObserver(mutations => {
        if (sessionStorage.getItem('cartTimerExpired')) {
          if (el.textContent.trim() !== "Checkout Now!") {
            updateDisplay(el);
          }
        } else if (sessionStorage.getItem('cartTimerTarget')) {
          if (!el.querySelector('.countdown-minutes') || !el.querySelector('.countdown-seconds')) {
            updateDisplay(el);
          }
        }
      });
      observer.observe(el, { childList: true, subtree: true, characterData: true });
      el._observerAttached = true;
    }
  
    function updateDisplay(countdownEl) {
      if (sessionStorage.getItem('cartTimerExpired')) {
        countdownEl.innerHTML = "Checkout Now!";
        countdownEl.classList.add('expired');
      } else if (sessionStorage.getItem('cartTimerTarget')) {
        startTimer(countdownEl);
      } else {
        countdownEl.innerHTML = defaultCountdownHTML;
      }
      observeCountdownElement(countdownEl);
    }
  
    function startTimer(countdown) {
      if (!countdown) return;
      if (countdown.intervalId) clearInterval(countdown.intervalId);
      const targetDate = new Date(parseInt(sessionStorage.getItem('cartTimerTarget')));
      
      function updateCountdown() {
        const now = Date.now();
        const timeDiff = targetDate - now;
        
        if (timeDiff <= 0) {
          countdown.innerHTML = "Checkout Now!";
          countdown.classList.add('expired');
          sessionStorage.setItem('cartTimerExpired', 'true');
          sessionStorage.removeItem('cartTimerTarget');
          clearInterval(countdown.intervalId);
          return;
        }
        
        const minutes = Math.floor(timeDiff / 60000);
        const seconds = Math.floor((timeDiff % 60000) / 1000);
        const minutesEl = countdown.querySelector('.countdown-minutes');
        const secondsEl = countdown.querySelector('.countdown-seconds');
        if (minutesEl && secondsEl) {
          minutesEl.textContent = minutes.toString().padStart(2, '0');
          secondsEl.textContent = seconds.toString().padStart(2, '0');
        }
      }
      
      countdown.intervalId = setInterval(updateCountdown, 1000);
      updateCountdown();
    }
  
    const existingCountdown = document.querySelector('.countdown-timer');
    if (existingCountdown) {
      updateDisplay(existingCountdown);
    }
  
    if (cartDrawer) {
      const drawerObserver = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'open' &&
            cartDrawer.hasAttribute('open')
          ) {
            if (!sessionStorage.getItem('cartTimerTarget') && !sessionStorage.getItem('cartTimerExpired')) {
              targetTime = Date.now() + 20 * 60000;
              sessionStorage.setItem('cartTimerTarget', targetTime);
            }
            const countdownEl = cartDrawer.querySelector('.countdown-timer');
            if (countdownEl) {
              updateDisplay(countdownEl);
            }
          }
        });
      });
      drawerObserver.observe(cartDrawer, { attributes: true });
    }
  
    if (cartDrawer) {
        const timerObserver = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
            const countdownEl = node.nodeType === Node.ELEMENT_NODE 
                ? (node.matches('.countdown-timer') ? node : node.querySelector('.countdown-timer'))
                : null;
    
            if (countdownEl) {
                if (countdownEl.intervalId) clearInterval(countdownEl.intervalId);
                updateDisplay(countdownEl);
            }
            });
        });
        });
        timerObserver.observe(cartDrawer, { childList: true, subtree: true });
    }
    if (cartDrawer) {
      const timerObserver = new MutationObserver(mutations => {
          mutations.forEach(mutation => {
              mutation.addedNodes.forEach(node => {
                  const isEmptyState = node.nodeType === Node.ELEMENT_NODE && 
                                    (node.classList.contains('empty-state') || node.querySelector('.empty-state'));
                  if (isEmptyState) {
                      sessionStorage.removeItem('cartTimerTarget');
                      sessionStorage.removeItem('cartTimerExpired');
                  }

                  const countdownEl = node.nodeType === Node.ELEMENT_NODE 
                      ? (node.matches('.countdown-timer') ? node : node.querySelector('.countdown-timer'))
                      : null;
          
                  if (countdownEl) {
                      if (countdownEl.intervalId) clearInterval(countdownEl.intervalId);
                      updateDisplay(countdownEl);
                  }
              });
          });
      });
      timerObserver.observe(cartDrawer, { childList: true, subtree: true });
  }
  });
  